export default __webpack_public_path__ + "static/media/template5.a7e159a2.jpg";